import React, { ReactNode } from 'react';
import './style.scss';

type GuidancesProps = {
  label?: ReactNode;
  label2?: string;
  label3?: string;
  annotation?: string;
  annotation2?: string;
  annotation3?: string;
  annotation4?: string;
  annotation5?: string;
  annotationLeft?: string;
  annotationRight?: string;
  annotationURL?: string;
  annotationLink?: string;
  isRowGapMin?: boolean;
};

export const Guidances = (props: GuidancesProps) => {
  const {
    label,
    label2,
    label3,
    annotation,
    annotationLeft,
    annotationRight,
    annotationURL,
    annotationLink,
    annotation2,
    annotation3,
    annotation4,
    annotation5,
    isRowGapMin,
  } = props;
  return (
    <div className={`guidances ${isRowGapMin ? 'guidancesMin' : ''}`}>
      <div className="guidances_label">{label}</div>
      <div className="guidances_label alignLeft">{label2}</div>
      <div className="guidances_label alignLeft">{label3}</div>
      <div className="guidances_separator" />
      <div className="guidances_annotation">{annotation}</div>
      <div className="guidances_annotation">
        {annotationLeft}
        <a href={annotationURL} target="_blank" rel="noreferrer">
          {annotationLink}
        </a>
        {annotationRight}
      </div>
      <div className="guidances_annotation">{annotation2}</div>
      <div className="guidances_annotation">{annotation3}</div>
      <div className="guidances_annotation">{annotation4}</div>
      <div className="guidances_annotation">{annotation5}</div>
    </div>
  );
};
